import styled from "@emotion/styled";
import TemplateHeader from "../../../components/templates/TemplateHeader";
import TemplateButton from "../../../components/templates/TemplateButton";

const Layout = styled.section``;

Layout.Container = styled.div`
  height: 100%;
  width: 100%;
  min-height: var(--preview-height);
  background: url(${({ backgroundImage }) => backgroundImage});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
`;

Layout.Content = styled.div`
  position: relative;
  top: -2px;
  color: ${({ theme }) => theme.palette.text.secondary};
  background: ${({ theme }) => theme.palette.secondary.main};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  padding: 96px 96px 0 96px;
`;

Layout.InnerContent = styled.div`
  padding: 0 30px;
`;

Layout.Header = styled(TemplateHeader)`
  height: 80px;
  padding: 0 96px;
`;

Layout.HeaderContent = styled.div`
  width: 1024px;
  height: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0 30px;
`;

Layout.Logo = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`

Layout.LogoImage = styled.img`
  height: 70px;
  justify-self: flex-start;
`

Layout.LogoText = styled.span`
  font-size: 22px;
  font-weight: 700;
  color: ${({ theme }) =>
    theme.palette.getContrastText("#000")};
`

Layout.HeroTitle = styled.h2`
  font-size: 95.4px;
  font-weight: bold;
  margin-bottom: 12px;
`;

Layout.Menu = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
`;

Layout.PhoneButton = styled(TemplateButton)`
  background-color: ${({ theme }) => theme.palette.primary.main};
  fill: ${({ theme }) =>theme.palette.secondary.main};
  color: ${({ theme }) =>theme.palette.secondary.main};
  text-transform: uppercase;
  line-height: 2.2;
  font-variant: normal;
  font-size: 14px;
  padding: 4px 26px;
  tab-index: -1;
  pointer-events: none;
  cursor: pointer;
  font-weight: bold;
  display: flex;
  align-items: center;
  border-radius: 0;
  gap: 8px;
`;

export default Layout;
